import {createAction} from '@reduxjs/toolkit'

export const resetPenaltyStatus = createAction('payLater/resetPenaltyStatus')

export const updatePayDueValid = createAction<Maybe<boolean>>('payLater/updatePayDueValid')
